export const UPDATE_EXPERIENCE_ENDPOINT = '/booking-portal/Appointment/UpdateBookExperience';
